import React from 'react';
import TopRightArrowIcon from '../../../../assets/Svg/TopRightArrowIcon';
import useConsentAuditDrawer from '../../../../common/ConsentAudit/useConsentAuditDrawer';
import ConsentAuditDrawer from '../../../../common/ConsentAudit/ConsentAuditDrawer';
import Button from '../../../../common/_custom/Button/Button';
import { ConsentType } from '../../../../common/ConsentAudit/types';
import styles from './GstOverview.module.scss';

interface GstConsentLogLinkProps {
    orgId: string;
    disabled?: boolean;
}

/**
 * Entry point for the org-wide GST consent panel — sits in the GST Overview header row, after
 * "Last Updated on …" and before the Signatories pill. Owns its own drawer state so the header
 * row above doesn't need to know about the fetch/download lifecycle. The organisation name
 * shown in the drawer header comes from the history response itself (`orgName` off the hook),
 * not redux — `selectedCompany` on this screen doesn't populate `orgName`.
 */
function GstConsentLogLink({ orgId, disabled = false }: Readonly<GstConsentLogLinkProps>) {
    const { open, loading, loadFailed, downloading, entries, orgName, openDrawer, closeDrawer, downloadAuditTrail } =
        useConsentAuditDrawer();

    return (
        <>
            <Button
                type="button"
                text="GST Consent Log"
                className={styles.GstConsentLogLink}
                icon={<TopRightArrowIcon width="14" height="14" />}
                disabled={disabled}
                onClick={() => {
                    if (disabled) return;
                    openDrawer({ orgId, type: ConsentType.GST });
                }}
            />
            <ConsentAuditDrawer
                open={open}
                onClose={closeDrawer}
                loading={loading}
                loadFailed={loadFailed}
                entries={entries}
                orgName={orgName}
                onDownload={downloadAuditTrail}
                downloading={downloading}
            />
        </>
    );
}

export default GstConsentLogLink;
